<script>
import micoapp_qrcode from '@/assets/images/otp_micoapp.jpg';
import QRCode from 'qrcode';
import { required } from 'vuelidate/lib/validators';
import { mapState } from 'vuex';
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from '@/state/helpers';
import i18n from '@/i18n';
import {
  DEFAULT_LOCALE,
  LOCALE_OPTIONS,
  detectBrowserLocale,
  getStoredLocale,
  persistLocale,
} from '@/utils/locale';

export default {
  name: 'Login',
  props: ['data'],
  emits: ['getBackInfo'],
  data() {
    return {
      // 输入框绑定值
      num11: undefined,
      num22: undefined,
      num33: undefined,
      num44: undefined,
      num55: undefined,
      num66: undefined,

      // 其他状态
      username: '',
      email: '',
      password: '',
      submitted: false,
      extendvoid: false,
      qrcodelogin: false,
      inputList: ['', '', '', '', '', ''],
      authcodes: '',
      keyboard: false,
      ismobile: false,
      loading: false,
      remember: false,
      logintype: 'password',
      otpcode: '',
      qrcodelink: '',
      qrcodeloading: true,
      qrcodelogin_request: false,
      qrcodecountdown: '',
      qrcodeexpire_seconds: 0,
      otp_status: false,
      isAuthError: false,
      authError: '',
      counter: 0,
      imgsrc: micoapp_qrcode,
      languages: LOCALE_OPTIONS.map((item) => ({
        flag: require(`@/assets/images/flags/${item.flag}.jpg`),
        language: item.locale,
        title: item.title,
      })),
      current_language: DEFAULT_LOCALE,
      languageDetected: false,
    };
  },
  computed: {
    ...mapState({
      notification: (state) => state.notification,
    }),
    pd() {
      return `${this.num11 || ''}${this.num22 || ''}${this.num33 || ''}${this.num44 || ''}${this.num55 || ''}${this.num66 || ''}`;
    },
  },
  watch: {
    pd(val) {
      this.getBackInfo(val);
    },
    data: {
      handler(val) {
        if (val) {
          let string = typeof val === 'number' ? val.toString() : val;
          let arr = string.split('');
          arr.forEach((item, index) => {
            const num = Number(item);
            this[`num${index + 1}${index + 1}`] = isNaN(num) ? undefined : num;
          });
        }
      },
      immediate: true,
    },
  },
  validations: {
    email: { required },
    password: { required },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,

    // Emit the getBackInfo event
    getBackInfo(value) {
      this.$emit('getBackInfo', value);
    },

    // loseBlur method
    loseBlur(id) {
      const key = `num${id}${id}`;
      let value = this[key];

      if (value === undefined || value === null) {
        this[key] = undefined;
        return;
      }

      // 保留第一个数字字符
      const newValue = String(value).replace(/\D/g, '').charAt(0) || undefined;
      this[key] = newValue;

      if (newValue) {
        const nextId = Number(id) + 1;
        if (nextId <= 6) {
          const nextInput = this.$refs[`num${nextId}`];
          nextInput && nextInput.focus();
        } else {
          const lastInput = this.$refs.num6;
          lastInput && lastInput.blur();
        }
      }
    },

    // 清空所有数字
    clearAllNumber() {
      this.num11 = '';
      this.num22 = '';
      this.num33 = '';
      this.num44 = '';
      this.num55 = '';
      this.num66 = '';
      this.$refs.num1 && this.$refs.num1.focus();
    },


    // 处理输入
    onInput(key) {
      this.authcodes = (this.authcodes + key).slice(0, 6);
      if (this.authcodes.length === 6) {
        this.tryToLogInExtend();
      }
    },

    onDelete() {
      this.authcodes = this.authcodes.slice(0, this.authcodes.length - 1);
    },

    // 处理登录尝试
    tryToLogIn() {
      this.submitted = true;
      // 触发 Vuelidate 的验证
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.$axios
          .post(this.apiuri, {
            action: 'login',
            username: this.email,
            password: this.password,
            remember: this.remember,
          })
          .then((response) => {
            if (response.data.status === 403) {
              this.toast(this.$t('login.needauth'));

              this.extendvoid = true;
              this.keyboard = true;
              this.isAuthError = true;
              this.authError = response.data.error || '';

              this.$refs.num1 && this.$refs.num1.focus();
            } else if (response.data.status === 200) {
              localStorage.setItem('user', JSON.stringify(response.data.data));
              this.tryingToLogIn = false;
              this.isAuthError = false;
              this.$refreshPermissions().then(() => {
                this.$router.push(this.$route.query.redirectFrom || { name: 'home' });
              });
            } else {
              this.toast(this.$t('login.loginerror'));
              this.isAuthError = true;
              this.authError = response.data.error || '';
            }
          })
          .catch((error) => {
            console.error('登录请求失败:', error);
            this.toast(this.$t('login.requestFailed'));
          });
      }
    },

    tryToLogInExtend() {
      var that = this;
      let authcodes = `${that.num11}${that.num22}${that.num33}${that.num44}${that.num55}${that.num66}`;
      if (authcodes.length !== 6) {
        return;
      }
      that.$axios
        .post(that.apiuri, {
          action: 'otplogin',
          authcodes: authcodes,
        })
        .then((response) => {
          if (response.data.status === 200) {
            localStorage.setItem('user', JSON.stringify(response.data.data));
            that.tryingToLogIn = false;
            that.isAuthError = false;
            that.$refreshPermissions().then(() => {
              that.$router.push(that.$route.query.redirectFrom || { name: 'home' });
            });
          } else {
            that.toast(that.$t('login.otploginerror'));
            that.isAuthError = true;
            that.authError = response.data.error || '';
          }
        })
        .catch((error) => {
          console.error('登录请求失败:', error);
          that.toast(that.$t('login.requestFailed'));
        });
    },

    nextFocus(el, index) {
      console.log(this.inputList);
      var numReg = /^[0-9]*$/;
      var numRe = new RegExp(numReg);
      if (numRe.test(el.key) || el.keyCode === 8) {
        var dom = this.$el.getElementsByClassName('border-input'),
          currInput = dom[index],
          nextInput = dom[index + 1],
          lastInput = dom[index - 1];
        /*这里的keyCode 根据不同的平台或许不同,安卓就是不是8*/
        if (el.keyCode !== 8) {
          this.inputList[index] = el.key;

          if (index < this.inputList.length - 1) {
            nextInput.focus();
          } else {
            currInput.blur();
            this.tryToLogInExtend();
          }
        } else {
          this.inputList[index] = '';
          if (index !== 0) {
            lastInput.focus();
          }
        }
      }
    },

    // 生成二维码
    async generateQRCode(qrcodelink) {
      try {
        const canvas = this.$refs.qrcodeCanvas;
        await QRCode.toCanvas(canvas, qrcodelink, { width: 400, height: 400 });
        this.qrcodeloading = false;
      } catch (error) {
        console.error('二维码生成失败:', error);
      }
    },

    // 切换登录类型
    changeLoginType(tab, event) {
      if (tab.name === 'qrcode') {
        this.qrcodeloading = true;
        this.$axios
          .post(this.apiuri, { action: 'wechatqrcodelogin' })
          .then((response) => {
            if (response.data.status === 200) {
              const qrcodelink = response.data.data.url;
              this.generateQRCode(qrcodelink);
              this.qrcodeexpire_seconds = response.data.data.expire_seconds;
              this.qrcodecountdown = setInterval(() => {
                this.qrcodeexpire_seconds--;
                if (this.qrcodeexpire_seconds === 0) {
                  clearInterval(this.qrcodecountdown); // 停止计时器
                  this.changeLoginType({ name: 'qrcode' });
                }
              }, 1000);
            } else {
              console.error('获取二维码链接失败');
            }
          })
          .catch((error) => {
            console.error('请求失败:', error);
          });
      }
    },

    // 检查登录
    checklogin(logincode, openid) {
      this.qrcodelogin_request = true;
      this.$axios
        .post(this.apiuri, { action: 'qrlogin', logincode, openid })
        .then((response) => {
          if (response.data.status === 200) {
            localStorage.setItem('user', JSON.stringify(response.data.data));
            this.tryingToLogIn = false;
            this.isAuthError = false;
            this.$refreshPermissions().then(() => {
              this.$router.push(this.$route.query.redirectFrom || { name: 'home' });
            });
            clearInterval(this.qrcodecountdown);
          } else {
            this.toast(this.$t('login.wechat_qrlogin_error'));
            this.isAuthError = true;
            this.authError = response.data.error || '';
          }
        })
        .catch((error) => {
          console.error('二维码登录失败:', error);
        });
    },

    // 获取 OTP 状态
    getotpstatus() {
      this.$axios
        .post(this.apiuri, { action: 'getotpstatus' })
        .then((response) => {
          if (response.data.status === 200) {
            this.otp_status = true;
            this.otp_enable = true;
          }
        })
        .catch((error) => {
          console.error('获取 OTP 状态失败:', error);
        });
    },

    // 显示通知
    toast(text, append = false) {
      this.counter++;
      this.$bvToast.toast(text, {
        title: this.$t('login.alter'),
        toaster: 'b-toaster-top-center',
        solid: true,
        appendToast: append,
      });
    },
    handleInput(id) {
      let value = this[`num${id}${id}`] || '';
      // 移除非数字字符
      value = value.replace(/\D/g, '');
      // 保留第一个字符
      value = value.charAt(0);
      this[`num${id}${id}`] = value;

      if (value) {
        this.$nextTick(() => {
          const nextId = Number(id) + 1;
          if (nextId <= 6) {
            const nextInput = this.$refs[`num${nextId}`];
            if (nextInput) {
              nextInput.focus();
            }
          } else {
            this.$refs.num6.blur();
            // 在最后一个输入后触发登录逻辑
            this.tryToLogInExtend();
          }
        });
      }
    },
    showOTPMicoapp() {
      this.$alert(
        `<img width="100%" src="${this.imgsrc}"><p>${this.$t("setting.system.otpbind_support_tip")}</p>`,
        this.$t("setting.system.otpbind_micoapp"),
        {
          confirmButtonText: this.$t("global.button.ok"),
          dangerouslyUseHTMLString: true,
          callback: (action) => {
            if (action === "confirm") {
              // 弹出输入框用于确认2FA验证码

            }
          },
        }
      );
    },
    switch_language() {
      const normalized = persistLocale(this.current_language);
      this.current_language = normalized;
      i18n.locale = normalized;
    },
    detectAndSetLanguage() {
      const savedLanguage = getStoredLocale();
      if (localStorage.getItem("language")) {
        this.current_language = savedLanguage;
        i18n.locale = savedLanguage;
        return;
      }

      const browserLanguage = detectBrowserLocale();
      if (browserLanguage && browserLanguage !== DEFAULT_LOCALE) {
        const normalized = persistLocale(browserLanguage);
        this.current_language = normalized;
        i18n.locale = normalized;
        this.languageDetected = true;
        this.$message({
          message: this.$t('login.language.autoDetected'),
          type: 'info',
          duration: 3000,
          showClose: true
        });
      } else {
        this.current_language = DEFAULT_LOCALE;
        i18n.locale = DEFAULT_LOCALE;
      }
    },
    resetLanguageDetection() {
      // 清除保存的语言设置，重新检测
      localStorage.removeItem("language");
      this.languageDetected = false;
      this.detectAndSetLanguage();
    }
  },
  mounted() {
    document.body.classList.add('auth-body-bg');
    let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag) {
      this.ismobile = true;
    }
    
    // 语言检测和设置
    this.detectAndSetLanguage();

    // 监听全局消息
    this.$bus.$on('message', (data) => {
      if (data.action === 'login' && data.status === 'success') {
        if (!this.qrcodelogin_request) this.checklogin(data.code, data.openid);
      }
    });

    this.getotpstatus();
  },
};
</script>

<template>
  <div class="login-page">
    <!-- 背景装饰 -->
    <div class="login-bg">
      <div class="bg-shapes">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
      </div>
    </div>

    <!-- 主内容区域 -->
    <div class="container-fluid">
      <div class="row">
        <!-- 左侧装饰区域 -->
        <div class="col-lg-6 d-none d-lg-flex align-items-center justify-content-center">
          <div class="login-left-content">
            <div class="brand-section">
              <img src="@/assets/images/login-logo.webp" alt="logo" class="brand-logo" />
              <h2 class="brand-title">{{ $t('login.welcome_title') }}</h2>
              <p class="brand-subtitle">{{ $t('login.welcome_subtitle') }}</p>
            </div>
            <div class="features-list">
              <div class="feature-item">
                <div class="feature-icon security-icon">
                  <i class="ri-shield-check-line"></i>
                </div>
                <div class="feature-content">
                  <span class="feature-title">{{ $t('login.feature.security.title') }}</span>
                  <span class="feature-desc">{{ $t('login.feature.security.desc') }}</span>
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-icon speed-icon">
                  <i class="ri-flashlight-line"></i>
                </div>
                <div class="feature-content">
                  <span class="feature-title">{{ $t('login.feature.fast.title') }}</span>
                  <span class="feature-desc">{{ $t('login.feature.fast.desc') }}</span>
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-icon global-icon">
                  <i class="ri-global-line"></i>
                </div>
                <div class="feature-content">
                  <span class="feature-title">{{ $t('login.feature.global.title') }}</span>
                  <span class="feature-desc">{{ $t('login.feature.global.desc') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧登录区域 -->
        <div class="col-lg-6 d-flex align-items-center justify-content-center py-5">
          <div class="login-form-container mx-auto">
            <!-- 移动端品牌区域 -->
            <div class="mobile-brand d-lg-none text-center mb-4">
              <img src="@/assets/images/login-logo.webp" alt="logo" class="mobile-logo" />
              <h4 class="mt-3">{{ $t('login.login') }}</h4>
            </div>

            <!-- 错误提示 -->
            <b-alert variant="danger" class="mt-3" v-if="notification.message" show dismissible>
              {{ notification.message }}
            </b-alert>

            <!-- 登录表单 -->
            <div class="login-form">
              <el-tabs v-model="logintype" type="card" @tab-click="changeLoginType" class="login-tabs">
                <el-tab-pane :label="$t('login.type.password')" name="password">
                  <form @submit.prevent="tryToLogIn" class="modern-form">
                    <div class="form-group">
                      <label class="form-label">
                        <i class="ri-user-line"></i>
                        {{ $t('login.username.text') }}
                      </label>
                      <input 
                        type="text" 
                        v-model="email" 
                        class="form-control modern-input" 
                        :placeholder="$t('login.username.placeholder')" 
                        :class="{ 'is-invalid': submitted && $v.email.$error }" />
                      <div v-if="submitted && $v.email.$error" class="invalid-feedback">
                        <span v-if="!$v.email.required">
                          {{ $t('login.username.noinput') }}
                        </span>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="form-label">
                        <i class="ri-lock-line"></i>
                        {{ $t('login.password.text') }}
                      </label>
                      <input 
                        v-model="password" 
                        type="password" 
                        class="form-control modern-input" 
                        :placeholder="$t('login.password.placeholder')" 
                        :class="{ 'is-invalid': submitted && $v.password.$error }" />
                      <div v-if="submitted && !$v.password.required" class="invalid-feedback">
                        {{ $t('login.password.noinput') }}
                      </div>
                    </div>

                    <div class="form-group">
                      <div class="form-check">
                        <input 
                          type="checkbox" 
                          class="form-check-input" 
                          id="remember"
                          v-model="remember" />
                        <label class="form-check-label" for="remember">
                          {{ $t('login.remember') }}
                        </label>
                      </div>
                    </div>

                    <div class="form-group">
                      <button class="btn btn-primary btn-lg w-100 modern-btn" type="submit" :disabled="loading">
                        <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                        {{ $t('login.login') }}
                      </button>
                    </div>
                  </form>
                </el-tab-pane>

                <el-tab-pane :label="$t('login.type.wechat')" name="qrcode">
                  <div class="qrcode-container">
                    <div v-if="qrcodeloading" class="loading">
                      <div class="spinner"></div>
                      <p>{{ $t('login.qrcode.loading') }}...</p>
                    </div>
                    <canvas v-show="!qrcodeloading" ref="qrcodeCanvas" class="qrcode-canvas"></canvas>
                    <p v-show="!qrcodeloading" class="qrcode-tip">
                      {{ $t('login.qrcode.timeout', { time: qrcodeexpire_seconds }) }}
                    </p>
                  </div>
                </el-tab-pane>

                <el-tab-pane :label="$t('login.type.otp')" name="otp">
                  <div v-if="otp_status">
                    <div class="otp-container">
                      <div class="otp-header">
                        <i class="ri-shield-keyhole-line"></i>
                        <h5>{{ $t('login.otp.title') }}</h5>
                        <p>{{ $t('login.otp.description') }}</p>
                      </div>
                      
                      <div v-if="ismobile" class="mobile-otp">
                        <van-password-input 
                          :value="authcodes" 
                          :length="6" 
                          :mask="false" 
                          :focused="keyboard"
                          @focus="keyboard = true" />
                        <van-number-keyboard 
                          :show="keyboard" 
                          @input="onInput" 
                          @delete="onDelete"
                          @blur="keyboard = false" />
                      </div>
                      
                      <div v-else class="desktop-otp">
                        <div class="otp-inputs">
                          <el-input 
                            class="otp-input" 
                            ref="num1" 
                            maxlength="1" 
                            @keyup="loseBlur('1')"
                            @input="handleInput('1')" 
                            v-model="num11" />
                          <el-input 
                            class="otp-input" 
                            ref="num2" 
                            maxlength="1" 
                            @keyup="loseBlur('2')"
                            @input="handleInput('2')" 
                            v-model="num22" />
                          <el-input 
                            class="otp-input" 
                            ref="num3" 
                            maxlength="1" 
                            @keyup="loseBlur('3')"
                            @input="handleInput('3')" 
                            v-model="num33" />
                          <el-input 
                            class="otp-input" 
                            ref="num4" 
                            maxlength="1" 
                            @keyup="loseBlur('4')"
                            @input="handleInput('4')" 
                            v-model="num44" />
                          <el-input 
                            class="otp-input" 
                            ref="num5" 
                            maxlength="1" 
                            @keyup="loseBlur('5')"
                            @input="handleInput('5')" 
                            v-model="num55" />
                          <el-input 
                            class="otp-input" 
                            ref="num6" 
                            maxlength="1" 
                            @keyup="loseBlur('6')"
                            @input="handleInput('6')" 
                            v-model="num66" />
                        </div>
                        <div class="otp-actions">
                          <el-button @click="clearAllNumber" size="small">
                            {{ $t("login.otp.reset") }}
                          </el-button>
                          <el-button @click="showOTPMicoapp" type="text" size="small">
                            <i class="ri-question-line"></i>
                            {{ $t('login.otp.help') }}
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="otp-disabled">
                    <i class="ri-shield-cross-line"></i>
                    <p>{{ $t('login.otp.notenabled') }}</p>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>

            <!-- 语言切换 -->
            <div class="language-switcher-bottom">
              <el-select 
                v-model="current_language" 
                :placeholder="$t('login.selectlanguage')" 
                @change="switch_language"
                size="small">
                <el-option 
                  v-for="val in languages" 
                  :label="val.title"
                  :value="val.language" 
                  :key="val.language">
                </el-option>
              </el-select>
              <el-button 
                type="text" 
                size="mini" 
                @click="resetLanguageDetection"
                style="margin-left: 8px; color: #909399;"
                :title="$t('login.language.resetDetection')">
                <i class="el-icon-refresh"></i>
              </el-button>
            </div>

            <!-- 页脚信息 -->
            <div class="login-footer">
              <div class="footer-content">
                <p class="copyright">
                  © 2016 Shijiazhuang MOE Information Technology Co., Ltd<br />
                  © 2015 AICO Group Limited company
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* 登录页面整体样式 */
.login-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.login-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.bg-shapes {
  position: relative;
  width: 100%;
  height: 100%;
}

.shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: float 6s ease-in-out infinite;
}

.shape-1 {
  width: 200px;
  height: 200px;
  top: 10%;
  left: 10%;
  animation-delay: 0s;
}

.shape-2 {
  width: 150px;
  height: 150px;
  top: 60%;
  right: 15%;
  animation-delay: 2s;
}

.shape-3 {
  width: 100px;
  height: 100px;
  bottom: 20%;
  left: 20%;
  animation-delay: 4s;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
}

/* 左侧内容区域 */
.login-left-content {
  color: white;
  text-align: center;
  padding: 2rem;
}

.brand-section {
  margin-bottom: 3rem;
}

.brand-logo {
  width: 180px;
  height: auto;
  margin-bottom: 1.5rem;
}

.brand-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.brand-subtitle {
  font-size: 1.2rem;
  opacity: 0.9;
  margin-bottom: 0;
}

.features-list {
  text-align: left;
  margin-top: 2rem;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  padding: 1rem 1.25rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.feature-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  transition: left 0.5s ease;
}

.feature-item:hover::before {
  left: 100%;
}

.feature-item:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateX(8px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

.feature-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
}

.feature-icon i {
  font-size: 1.8rem;
  z-index: 2;
  position: relative;
  color: white !important;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
  display: block !important;
  line-height: 1;
}

.security-icon {
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
}

.speed-icon {
  background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%);
  box-shadow: 0 4px 15px rgba(255, 152, 0, 0.3);
}

.global-icon {
  background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);
  box-shadow: 0 4px 15px rgba(33, 150, 243, 0.3);
}

.feature-content {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.feature-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 0.25rem;
  display: block;
}

.feature-desc {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.3;
  display: block;
}

/* 登录表单容器 */
.login-form-container {
  background: white;
  border-radius: 20px;
  padding: 2.5rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 450px;
  position: relative;
  z-index: 2;
  margin: 0 auto;
}

.mobile-brand {
  margin-bottom: 2rem;
}

.mobile-logo {
  width: 120px;
  height: auto;
}

.language-switcher-bottom {
  text-align: center;
  margin: 1.5rem 0;
}

/* 登录表单样式 */
.login-form {
  margin-top: 1rem;
}

.login-tabs {
  border: none;
}

.login-tabs .el-tabs__header {
  margin-bottom: 2rem;
}

.login-tabs .el-tabs__nav {
  border: none;
}

.login-tabs .el-tabs__item {
  border: none;
  border-radius: 10px;
  margin-right: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: #f8f9fa;
  color: #666;
  transition: all 0.3s ease;
  font-weight: 500;
}

.login-tabs .el-tabs__item:hover {
  background: #e9ecef;
  color: #333;
}

.login-tabs .el-tabs__item.is-active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
  transform: translateY(-2px);
}

.modern-form {
  padding: 0;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-label {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
}

.form-label i {
  margin-right: 0.5rem;
  color: #667eea;
}

.modern-input {
  border: 2px solid #e9ecef;
  border-radius: 10px;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.modern-input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
}

.modern-btn {
  border-radius: 10px;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  font-size: 1rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  transition: all 0.3s ease;
}

.modern-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
}

/* 二维码容器 */
.qrcode-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 0;
}

.qrcode-canvas {
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.qrcode-tip {
  margin-top: 1rem;
  color: #666;
  font-size: 0.9rem;
}

.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #333;
}

.spinner {
  width: 60px;
  height: 60px;
  border: 4px solid rgba(102, 126, 234, 0.1);
  border-top-color: #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* 卡片登录占位符 */
.card-login-placeholder {
  text-align: center;
  padding: 3rem 0;
  color: #999;
}

.card-login-placeholder i {
  font-size: 3rem;
  margin-bottom: 1rem;
}

/* OTP 容器 */
.otp-container {
  padding: 1rem 0;
}

.otp-header {
  text-align: center;
  margin-bottom: 2rem;
}

.otp-header i {
  font-size: 2.5rem;
  color: #667eea;
  margin-bottom: 1rem;
}

.otp-header h5 {
  margin-bottom: 0.5rem;
  color: #333;
}

.otp-header p {
  color: #666;
  font-size: 0.9rem;
}

.otp-inputs {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.otp-input {
  width: 50px;
}

.otp-input .el-input__inner {
  text-align: center;
  font-size: 1.2rem;
  font-weight: bold;
  border-radius: 10px;
  border: 2px solid #e9ecef;
}

.otp-input .el-input__inner:focus {
  border-color: #667eea;
}

.otp-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.otp-disabled {
  text-align: center;
  padding: 3rem 0;
  color: #999;
}

.otp-disabled i {
  font-size: 3rem;
  margin-bottom: 1rem;
}

/* 页脚 */
.login-footer {
  margin-top: 2rem;
  text-align: center;
}

.copyright {
  color: #999;
  font-size: 0.85rem;
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .login-form-container {
    margin: 1rem auto;
    padding: 1.5rem;
    max-width: 400px;
  }
  
  .brand-title {
    font-size: 2rem;
  }
  
  .brand-subtitle {
    font-size: 1rem;
  }
  
  .otp-inputs {
    gap: 0.25rem;
  }
  
  .otp-input {
    width: 40px;
  }
}

@media (max-width: 576px) {
  .login-form-container {
    margin: 0.5rem auto;
    padding: 1rem;
    max-width: 350px;
  }
  
  .login-tabs .el-tabs__item {
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
  }
}
</style>